import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../../../services/authentication.service';
import { EventosService } from '../../../services/eventos.service';
import { ClasesService } from '../../../services/clases.service';
import { UserService } from '../../../services/user.service';
import { NotificacionesService } from './../../../services/notificaciones.service';
import { AngularFireFunctions } from '@angular/fire/functions';
import { BreadcrumbService } from 'src/app/services/breadcrumb.service';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import { take } from 'rxjs/operators';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-eventos',
  templateUrl: './eventos.component.html',
  styleUrls: ['./eventos.component.css'],
})
export class EventosComponent implements OnInit {
  userUid: any;
  nombre: string;
  descripcion: string;
  clase: any;
  estudiantes = [];
  fechainicio: any;
  horainicio: any;
  fechafinal: any;
  horafinal: any;
  userdata: any;
  clases = [];
  clasesSeleccionadas = [];
  selectclase: any;
  selectuser = [];
  invitados: any = 'clase';
  usuariosparaclase: any;
  clasetoda = [];
  notificacion: any;
  estudianteDatos: any;
  clicked = false;
  ocultarForm = false;
  videollamada: any = 'no';
  linkvideo: string = '';
  emails: any = new Array();
  email: any;
  formatoEmailMensaje: string;
  usuario: any;
  usuariosClasesSeleccionadas: any = [];
  fechaHoy: string = '';
  horaHoy: string;
  ninguna: boolean = false;

  clasesCapadas = [
    '0MYFZ2lrZKZ69JjARsVB',
    '0MYFrkjV4l2THtX6CLGZ',
    '000LlElEx00000000',
    '000LlElEx00000001',
    '000LlElEx00000002',
    '000LlElEx00000003',
    '000LlElEx00000004',
    '000LlElEx00000005',
    '000LlElEx00000006',
    '000LlElEx00000007',
    '000LlElEx00000008',
    '000LlElEx00000009',
    '000LlElEx00000010',
    '000LlElEx00000011',
    '000LlElEx00000012',
    '000LlElEx00000013',
    '000LlElEx00000014',
    '000LlElEx00000015',
    '000LlElEx00000016',
    '000LlElEx00000017',
    '000LlElEx00000018',
  ];

  constructor(
    private activatedRoute: ActivatedRoute,
    private eventosService: EventosService,
    private clasesService: ClasesService,
    private userService: UserService,
    private notificacionesService: NotificacionesService,
    private functions: AngularFireFunctions,
    private router: Router,
    private breadService: BreadcrumbService,
    private authenticationService: AuthenticationService,
    private translate: TranslateService,
    private datepipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.estudiantes = new Array();
    this.getmainuserdata();
  }

  /* trae informacion principal del usuario logueado */
  getmainuserdata() {
    this.getFechaActual();
    this.fechainicio = this.fechaHoy;
    this.fechafinal = this.fechaHoy;
    this.horainicio = this.horaHoy;
    this.horafinal = this.horaHoy;

    const Userdata: any = this.userService.getUserinfodata();

    if (Userdata === undefined) {
      this.authenticationService
        .isAuth()
        .pipe(take(1))
        .subscribe((auth) => {
          if (auth) {
            this.userUid = auth.uid; /* id del usuario */

            this.authenticationService
              .isUserAdmin(this.userUid)
              .pipe(take(1))
              .subscribe((userdata) => {
                if (userdata[0]) {
                  this.userdata = userdata[0];
                  this.usuario = this.userdata.usuario;
                  const clasesValidas = this.userdata.clases;

                  if (clasesValidas.length > 0) {
                    forkJoin(
                      clasesValidas.map((clase: string) =>
                        this.clasesService.getClaseById(clase).pipe(take(1))
                      )
                    ).subscribe((clases: any[]) => {
                      this.clases = clases.filter(
                        (tclase) => tclase.payload.exists
                      );
                    });
                  } else {
                    this.clases = [];
                  }
                }
              });
          }
        });
    } else {
      this.userUid = Userdata.payload.doc.data().uid; /* id del usuario */
      this.userdata = Userdata.payload.doc.data();
      this.usuario = Userdata.payload.doc.data().usuario;

      const clasesValidas = this.userdata.clases;

      if (clasesValidas.length > 0) {
        forkJoin(
          clasesValidas.map((clase: string) =>
            this.clasesService.getClaseById(clase).pipe(take(1))
          )
        ).subscribe((clases: any[]) => {
          this.clases = clases.filter((tclase) => tclase.payload.exists);
        });
      } else {
        this.clases = [];
      }
    }
  }

  // selectclass(event) {
  //   this.clasesService.getClaseById(event).subscribe((clase) => {
  //     this.selectclase = clase.payload.data();
  //     this.selectuser = [];
  //     this.clasetoda = [];
  //     this.selectclase.usuarios.forEach((seclase) => {
  //       if (seclase != this.userUid) {
  //         this.userService.getUserById(seclase).subscribe((user) => {
  //           this.selectuser.push(user[0]);
  //           this.usuariosparaclase = user[0].payload.doc.data();
  //           this.clasetoda.push(this.usuariosparaclase.uid);
  //         });
  //       }
  //     });
  //   });
  // }

  // selectinvitados(event) {
  //   this.clasesService.getClaseById(this.clase).subscribe((clase) => {
  //     this.selectclase = clase.payload.data();
  //     this.clasetoda = [];
  //     this.selectclase.usuarios.forEach((seclase) => {
  //       if (seclase != this.userUid) {
  //       this.userService.getUserById(seclase).subscribe((user) => {
  //         this.usuariosparaclase = user[0].payload.doc.data();
  //         this.clasetoda.push(this.usuariosparaclase.uid);
  //       });
  //     }
  //     });
  //   });
  // }

  getFecha() {
    const current = new Date();
    current.setHours(current.getHours());
    current.setMinutes(current.getMinutes());
    current.setMonth(current.getMonth());
    current.setDate(current.getDate());
    return current;
  }

  getFechaActual() {
    var MyDate = this.getFecha();

    this.fechaHoy =
      MyDate.getFullYear() +
      '-' +
      ('0' + (MyDate.getMonth() + 1)).slice(-2) +
      '-' +
      ('0' + MyDate.getDate()).slice(-2);

    this.horaHoy =
      ('0' + MyDate.getHours()).slice(-2) +
      ':' +
      ('0' + MyDate.getMinutes()).slice(-2);
  }

  async createevent() {
    this.ocultarForm = true;
    this.notificacion = '';

    try {
      // 1️⃣ Validar datos
      const valid = await this.validarCampos();
      if (!valid) return;

      // 2️⃣ Construir objeto evento
      const evento = this.construirEvento();

      // 3️⃣ Guardar evento en backend
      const evnt = await this.eventosService.createdEvento(evento);

      // 4️⃣ Notificación de éxito
      await this.mostrarMensaje('dashboard.eventos.notificacion.creado');
      setTimeout(() => {
        this.router.navigate([
          `/dashboard/profile/${this.userUid}/miseventos/`,
        ]);
      }, 2000);

      // 5️⃣ Crear notificaciones internas
      this.crearNotificacionesInternas(evento, evnt.id);

      // 6️⃣ Enviar emails a invitados
      this.enviarEmails(evento, evnt.id);
    } catch (error) {
      console.error('Error creando evento:', error);
      this.notificacion = 'Error al crear el evento. Inténtalo de nuevo.';
    }
  }

  //
  // 🔹 MÉTODOS AUXILIARES
  //

  // Mostrar notificación traducida
  private async mostrarMensaje(key: string) {
    const data = await this.translate.get(key).toPromise();
    this.notificacion = data;
    setTimeout(() => {
      this.ocultarForm = false;
      setTimeout(() => {
        this.activarCheckboxClases();
        this.activarCheckboxUsuarios();
      }, 500);
    }, 1500);
  }

  // Validar campos obligatorios
  private async validarCampos(): Promise<boolean> {
    if (!this.nombre)
      return this.mostrarMensaje('dashboard.eventos.notificacion.nombre').then(
        () => false
      );
    if (this.clasesSeleccionadas.length === 0 && this.emails.length === 0)
      return this.mostrarMensaje('dashboard.eventos.notificacion.clase').then(
        () => false
      );
    if (!this.invitados && this.emails.length === 0)
      return this.mostrarMensaje(
        'dashboard.eventos.notificacion.opcioninvitados'
      ).then(() => false);
    if (this.estudiantes.length <= 0 && this.emails.length === 0)
      return this.mostrarMensaje(
        'dashboard.eventos.notificacion.invitados'
      ).then(() => false);
    if (!this.fechainicio)
      return this.mostrarMensaje(
        'dashboard.eventos.notificacion.fechaini'
      ).then(() => false);
    if (!this.horainicio)
      return this.mostrarMensaje('dashboard.eventos.notificacion.horaini').then(
        () => false
      );
    if (!this.fechafinal)
      return this.mostrarMensaje(
        'dashboard.eventos.notificacion.fechafin'
      ).then(() => false);
    if (!this.horafinal)
      return this.mostrarMensaje('dashboard.eventos.notificacion.horafin').then(
        () => false
      );
    if (this.fechafinal < this.fechainicio)
      return this.mostrarMensaje(
        'dashboard.eventos.notificacion.fechainimenor'
      ).then(() => false);
    if (
      this.fechainicio === this.fechafinal &&
      this.horafinal < this.horainicio
    )
      return this.mostrarMensaje(
        'dashboard.eventos.notificacion.fechainidia'
      ).then(() => false);

    const fechaActual = this.getFecha();
    const fechaInicialComprobacion = new Date(
      `${this.fechainicio} ${this.horainicio}`
    );
    if (fechaActual > fechaInicialComprobacion)
      return this.mostrarMensaje(
        'dashboard.eventos.notificacion.fechapasado'
      ).then(() => false);

    return true;
  }

  // Construir objeto evento
  private construirEvento() {
    if (!this.descripcion) this.descripcion = '';
    if (this.videollamada === 'si') {
      this.linkvideo = `https://demo.colegia.education/${this.userdata.usuario}`;
    }
    if (!this.estudiantes.includes(this.userUid)) {
      this.estudiantes.push(this.userUid);
    }

    return {
      nombre: this.nombre.toLowerCase(),
      descripcion: this.descripcion,
      clase:
        this.clasesSeleccionadas.length > 0
          ? this.clasesSeleccionadas[0]
          : null,
      clases: this.clasesSeleccionadas,
      estudiantes: this.estudiantes,
      fecha_inicio: new Date(`${this.fechainicio} ${this.horainicio}`),
      fechainicio: this.fechainicio,
      horainicio: this.horainicio,
      fecha_final: new Date(`${this.fechafinal} ${this.horafinal}`),
      fechafinal: this.fechafinal,
      horafinal: this.horafinal,
      creado: this.userUid,
      asistentes: [] as string[],
      noasistentes: [] as string[],
      videoconferencia: this.linkvideo,
      emails: this.emails,
    };
  }

  // Crear notificaciones internas
  private crearNotificacionesInternas(evento: any, eventId: string) {
    this.estudiantes.forEach((estudiante) => {
      const notification = {
        user: estudiante,
        texto: `📅 ${evento.nombre}`,
        url: `/dashboard/profile/${estudiante}/miseventos`,
        verlo: estudiante,
        fecha: new Date(),
        event_id: eventId,
        emisor: this.userUid,
        mensaje: false,
      };
      this.notificacionesService.createdNotificacion(notification);

      if (this.userUid !== estudiante) {
        this.sendNotification(estudiante, this.nombre);
      }
    });
  }

  // Enviar emails a invitados
  private enviarEmails(evento: any, eventId: string) {
    const len = localStorage.getItem('idioma');
    const apiMap: Record<string, string> = {
      en: this.linkvideo ? 'sendEmailEn' : 'sendEmailNoVideoEn',
      es: this.linkvideo ? 'sendEmail' : 'sendEmailNoVideo',
      ar: this.linkvideo ? 'sendEmailEn' : 'sendEmailNoVideoEn',
    };
    const api =
      apiMap[len || ''] ||
      (this.linkvideo ? 'sendEmailEn' : 'sendEmailNoVideoEn');

    const fecha = new Date(`${this.fechainicio} ${this.horainicio}`);
    const fechaFin = new Date(`${this.fechafinal} ${this.horafinal}`);
    const fechaEmail = this.datepipe.transform(fecha, 'dd/MM/yyyy');
    const fechaFinEmail = this.datepipe.transform(fechaFin, 'dd/MM/yyyy');

    const eventParse = {
      titulo: quitarCaracteresEspeciales(this.nombre),
      fecha: fecha.toISOString().replace(/[-:.]/g, ''),
      fechafin: fechaFin.toISOString().replace(/[-:.]/g, ''),
      descripcion: this.descripcion,
      organizador: this.userdata.email,
    };

    const linkEmail = this.linkvideo || 'https://demo.colegia.education/';

    this.emails.forEach((email) => {
      const callable = this.functions.httpsCallable(api);
      callable({
        email,
        titulo: this.nombre,
        fecha: fechaEmail,
        hora: this.horainicio,
        fechafin: fechaFinEmail,
        horafin: this.horafinal,
        link: linkEmail,
        event: eventParse,
        nombre: `${this.userdata.nombres} ${this.userdata.apellidos}`,
      }).subscribe();
    });
  }

  getUserId(event, uid) {
    if (event.target.checked) {
      this.estudiantes.push(uid);
    } else {
      this.estudiantes = this.estudiantes.filter((m) => m != uid);
    }
  }
  addEmail() {
    if (this.validateEmail(this.email)) {
      if (!this.emails.includes(this.email)) {
        this.emails.push(this.email);
        this.email = '';
      }
    } else {
      this.translate.get('dashboard.eventos.formatoemail').subscribe((data) => {
        this.formatoEmailMensaje = data;
        setTimeout(() => {
          this.formatoEmailMensaje = '';
        }, 2000);
      });
    }
  }

  quitarEmail(email) {
    var posicion = this.emails.indexOf(email);
    this.emails.splice(posicion, 1);
  }

  UpdateBreadcrumb(name, url) {
    this.breadService.addtobread(name, url);
  }

  validateEmail(email) {
    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  selectClase(event, uid) {
    if (event.target.checked) {
      this.ninguna = false;
      this.clasesSeleccionadas.push(uid);
    } else {
      this.clasesSeleccionadas = this.clasesSeleccionadas.filter(
        (m) => m != uid
      );
      // this.quitarUsuarios(uid);
      this.estudiantes = [];
    }
    this.usuariosClasesSeleccionadas = [];

    setTimeout(() => {
      this.recogerUsuarios();
    }, 500);
  }

  ningunaClase(event) {
    if (event.target.checked) {
      this.ninguna = true;
      this.clasesSeleccionadas = [];
      this.usuariosClasesSeleccionadas = [];
      this.videollamada = 'si';
    } else {
      this.ninguna = false;
    }
  }

  recogerUsuarios() {
    this.usuariosClasesSeleccionadas = [];
    this.clasetoda = [];
    this.estudiantes = [];
    for (const clase of this.clasesSeleccionadas) {
      this.userService.getUsersbyClass(clase).subscribe((usuarios) => {
        for (const usuario of usuarios) {
          this.usuariosClasesSeleccionadas =
            this.usuariosClasesSeleccionadas.filter(
              (m) => m.payload.doc.id != usuario.payload.doc.id
            );
          this.usuariosClasesSeleccionadas.push(usuario);
          this.clasetoda = this.clasetoda.filter(
            (m) => m != usuario.payload.doc.data()['uid']
          );
          this.clasetoda.push(usuario.payload.doc.data()['uid']);
        }
        this.usuariosClasesSeleccionadas =
          this.usuariosClasesSeleccionadas.filter(
            (m) => m.payload.doc.data().uid != this.userUid
          );
        this.clasetoda = this.clasetoda.filter((m) => m != this.userUid);
        if (this.invitados == 'clase') {
          this.estudiantes = this.clasetoda;
        } else {
          this.estudiantes = [];
        }
      });
    }
  }

  activarCheckboxClases() {
    if (this.clasesSeleccionadas.length == 0) {
      var a = document.querySelector('input[name=' + this.clase + ']');
      a['checked'] = true;
    } else {
      this.clasesSeleccionadas.forEach((clase) => {
        var a = document.querySelector('input[name=' + clase + ']');
        a['checked'] = true;
      });
    }
    // var a = document.querySelector("input[name='ab6lOfAWaSY3nQwUHCQtbKDJBWx1']")
    // a['checked']=true;
    // console.log(a)
  }

  activarCheckboxUsuarios() {
    setTimeout(() => {
      this.estudiantes.forEach((usuario) => {
        var a = document.querySelector('input[name=' + usuario + ']');
        a['checked'] = true;
      });
    }, 1000);

    // var a = document.querySelector("input[name='ab6lOfAWaSY3nQwUHCQtbKDJBWx1']")
    // a['checked']=true;
    // console.log(a)
  }

  sendNotification(usuario, mensaje) {
    var dataTrans = {
      uid: usuario,
      nombre: this.userdata['nombres'] + ' ' + this.userdata['apellidos'],
      texto: '📅 ' + mensaje,
    };
    var jsonbody = JSON.stringify(dataTrans);
    const url =
      'https://us-central1-colegia-education-demo.cloudfunctions.net/app/sendNotification';
    fetch(url, {
      method: 'POST',
      body: jsonbody,
    }).then(() => {});
  }

  // quitarUsuarios(claseuid){
  //   this.userService.getUsersbyClass(claseuid).subscribe(usuarios=>{
  //     for (const usuario of usuarios) {
  //       this.estudiantes = this.estudiantes.filter((m) => m != usuario.payload.doc.data()['uid']);
  //     }
  //   })
  // }
}

function quitarCaracteresEspeciales(titulo: string) {
  return titulo
    .split('.')
    .join('_')
    .split('.')
    .join('_')
    .split('/')
    .join('_')
    .split(':')
    .join('_')
    .split('*')
    .join('_')
    .split('?')
    .join('_')
    .split('"')
    .join('_')
    .split('<')
    .join('_')
    .split('>')
    .join('_')
    .split('|')
    .join('_')
    .split(' ')
    .join('_');
}
